let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("9ClHX")).then(() => parcelRequire('8nyI6'));